import React,{ useState, useEffect,useRef} from "react";
import {Select,message} from "antd";
import { typeMap3 } from "@/constants/dataMap";

interface searchElementProps 
{
    style:any;
    dataSource:any;
    searchElementChange:(node,val) => void;
    selectName:any;
}

const searchElement: React.FC<searchElementProps> = ({style,dataSource,searchElementChange,selectName}) => 
{
    const [messageApi, contextHolder] = message.useMessage();
    const defaultOptions = 
    [
        {
            label:<span>设备</span>,
            title:"设备",
            options:[],
        },
        {
            label:<span>流股</span>,
            title:"流股",
            options:[],
        },
    ]
    const [options,setOptions] = useState(defaultOptions);

    useEffect(() => 
    {
        queryNewData();
    },[]);

    const queryNewData = () =>
    {
        if(dataSource)
        {
            const nodeDataArray = dataSource.nodeDataArray;
            const linkDataArray = dataSource.linkDataArray;

            let nodeOptions = [];
            for(let i=0;i<nodeDataArray.length;i++)
            {
                let nodeName = nodeDataArray[i].nodeName;
                if(nodeName && (!nodeDataArray[i].isGroup))
                {
                    let nodeOption = {label:nodeName,value:nodeName,type:"node"};
                    nodeOptions.push(nodeOption);
                }
            }

            let linkOptions = [];
            for(let i=0;i<linkDataArray.length;i++)
            {
                let linkName = linkDataArray[i].linkName;
                if(linkName)
                {
                    let linkOption = {label:linkName,value:linkName,type:"link"};
                    linkOptions.push(linkOption);
                }
            }

            let newOptions =
            [
                {
                    label:<span>设备</span>,
                    title:"设备",
                    options:nodeOptions,
                },
                {
                    label:<span>流股</span>,
                    title:"流股",
                    options:linkOptions,
                },
            ]
            
            setOptions(newOptions);
        }
    }

    return (
        <>
        {contextHolder}
        <div>
            <Select
                value={selectName}
                onChange={(val,e) => 
                {
                    if (!val) return;
                    if(e)
                    {
                        if(e["type"]==="node")
                        {
                            let nodeData = dataSource.nodeDataArray.find(item=>item.nodeName===e["value"]);
                            if(nodeData)
                            {
                                let node = 
                                {
                                    elementCategory:typeMap3[nodeData.type],
                                    elementName:e["value"],
                                    groupKey:nodeData.group?String(nodeData.group):"无",
                                    groupName:nodeData.group?dataSource.nodeDataArray.find(item=>item.key===nodeData.group && item.isGroup).groupName:"无工艺段",
                                    itemKey:nodeData.key,
                                    path:["groups",nodeData.group?String(nodeData.group):"无","elements",typeMap3[nodeData.type],e["value"]],
                                    type:"element_item"
                                };
                                searchElementChange(node,val);
                            }
                        }
                        else if(e["type"]==="link")
                        {
                            let linkData = dataSource.linkDataArray.find(item=>item.linkName===e["value"]);
                            if(linkData)
                            {
                                let link = 
                                {
                                    streamName:e["value"],
                                    groupKey:linkData.group[0]?String(linkData.group[0]):"无",
                                    groupName:linkData.group[0]?dataSource.nodeDataArray.find(item=>item.key===linkData.group[0] && item.isGroup).groupName:"无工艺段",
                                    itemKey:linkData.key,
                                    path:["groups",linkData.group[0]?String(linkData.group[0]):"无","streams",e["value"]],
                                    type:"stream_item"
                                };
                                searchElementChange(link,val);
                            }
                        }
                    }
                }}
                style={style}
                options={options}
                showSearch
            />
        </div>
        </>
    );
};

export default searchElement;